import type { ChangelogEntry } from "../types";

/** Belegg, pakkeliste og kopier booking for utstyr. */
export const UTSTYR_BELEGG_2026_10: ChangelogEntry = {
  id: "2026-10-25-utstyr-belegg",
  date: "2026-10-25",
  title: "Belegg og pakkeliste for utstyr",
  summary:
    "Se hva som er booket når på tvers av prosjekter, få en pakkeliste for prosjektet og kopier en booking til et annet prosjekt eller nye datoer.",
  sections: [
    {
      heading: "Utstyr",
      minRole: "user",
      items: [
        {
          title: "Belegg",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Bookbart utstyr dag for dag, to uker om gangen, gruppert på Oslo og Bergen. Blokkene viser prosjektnummeret, ⚠ betyr dobbeltbooket og skravert betyr på service. Klikk på en blokk for å åpne bookingen, eller på en ledig dag for å booke. På mobil vises «Booket i dag» og «Neste 7 dager».",
        },
        {
          title: "Pakkeliste fra prosjektfanen",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Alt som er booket på prosjektet, med deler og tilbehør, notat og egne datoer. Kryss av mens du pakker (avkrysningen lagres ikke), del lenken eller skriv den ut.",
        },
        {
          title: "Kopier booking",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Åpne en booking og velg «Kopier booking» for å booke det samme utstyret på et annet prosjekt eller nye datoer. Alle linjene flyttes like mange dager.",
        },
      ],
    },
  ],
};
